module.exports = __webpack_public_path__ + "fonts/question-ask-gray.svg";